/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-16 13:43:35
 * @LastEditors: zhangle
 * @LastEditTime: 2023-02-23 14:30:51
 */
import TsaSetOrForgetPassword from '@/components/setOrForgetPassword/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const SetOrForgetPassword = vue.extend(TsaSetOrForgetPassword)
    if (!$vm) {
      $vm = new SetOrForgetPassword({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const setOrForgetPassword = {
      show (options = {}) {
        $vm.show = true
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaSetOrForgetPassword) {
      vue.prototype.$TsaSetOrForgetPassword = setOrForgetPassword
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/setOrForgetPassword/index.js